<template>
  <!-- Footer -->
  <mdb-footer color="special-color" class="font-small pt-4 mt-4">
    <mdb-container fluid >
			
		<div class="text-center py-3">
			<ul class="list-inline mb-0">
				<li class="list-inline-item"><a href="#!">Home</a></li>
				<li class="list-inline-item"><a href="#!">Sitemap</a></li>
				<li class="list-inline-item"><a href="#!">Privacy</a></li>
            
      </ul>
    </div>

    </mdb-container>	

    <div class="footer-copyright text-center py-3">
      <mdb-container fluid>
        &copy; 2019 Copyright: <a href="#"> EEDemo</a>
      </mdb-container>
    </div>

  </mdb-footer>
  <!-- Footer -->
</template>

<script>
  import { mdbFooter, mdbContainer, mdbRow, mdbCol } from 'mdbvue';
  export default {
    name: 'FooterBasic',
    components: {
      mdbFooter,
      mdbContainer,
      mdbRow,
      mdbCol
    }
  }
</script>

<style scoped>

</style>